<template>
  <!-- 日期选择 -->
  <div class="calendar_mask" v-if="isShowCalendar">
      <div class="calendar">
        <p class="calendar_title">
          <span class="cancel_" @click="calendarCancel()">取消</span>
          <span class="choose_date">选择时间</span>
          <span class="confim_" @click="calendarConfirm()">确定</span>
        </p>
        <p class="calendar_current_month">
          <span class="pre_month" @click="prevMonth">
            <img class="arrow_" src="../../../../assets/image/nsale/caret-left.png" alt="">
          </span>
          <span class="current_date">{{dateYYMM}}</span>
          <span class="next_month" @click="nextMonth">
            <img class="arrow_" src="../../../../assets/image/nsale/caret-right.png" alt="">
          </span>
        </p>
        <!-- 星期 -->
        <div class="calendar-week clear">
          <div v-for="(item,index) in calendarTileArr" :key="index" class="calendar-week-item">{{item}}</div>
        </div>
        <!-- 日期 -->
        <div class="calendarDate">
          <div v-for="(item,index) in calendarDateTempArr"  :key="index" class="date">
            <!-- <div v-if="moment(item.dateFormat).diff(moment(firstDataOfCurrentMonth),'days') < 0" class="date_con" :class="{active : activeDateIndex === index}" @click="clickDay(item,index)">
              <span></span>
            </div>
            <div v-else-if="(queryParams.startDate && moment(maxDate).diff(moment(item.dateFormat),'days') >= 0 && moment(item.dateFormat).diff(moment(queryParams.startDate),'days') >= 0) || (!queryParams.startDate && moment(maxDate).diff(moment(item.dateFormat),'days') >= 0)" class="date_con" :class="{active : activeDateIndex === index}" @click="clickDay(item,index)">
              <span>{{item.day}}</span>
            </div> -->
            <div class="date_con" :class="{active : activeDateIndex === index}" @click="clickDay(item,index)">
              <span :class="item.enableClick?'':'disabled_'">{{item.day}}</span>
            </div>
          </div>
        </div>
        <div class="line_"></div>
        <div class="btns">
          <button class="today_" @click="todayEvt">今天</button>
          <button class="confirm_" @click="calendarConfirm">确定</button>
        </div>
      </div>
  </div>
</template>

<script>
import moment from 'moment'
const positions = ['bottom']
let cur = 0
let maxDate = moment(new Date()).format('YYYY-MM-DD')
let strDatepart = maxDate.split('-')
export default {
  props: {
    queryParams: {
      type: Object,
      required: true
    },
    dateType: { // 选择开始或者结束时间
      type: String,
      default: 'startDate'
    }
  },
  data () {
    let { year, month, day } = this.getNewDate(new Date(strDatepart[0], strDatepart[1] - 1, 1))
    return {
      isShowCalendar: false,
      time: { year, month, day },
      calendarTileArr: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
      resultDateList: [],
      calendarDateTempArr: [],
      dateYYMM: '',
      position: '',
      activeDateIndex: '',
      firstDataOfCurrentMonth: year + '-' + (month + 1) + '-' + day,
      maxDate: moment(new Date()).subtract(3, 'months').format('YYYY-MM-DD')
    }
  },
  watch: {
    isShowCalendar (val) {
      if (val) {
        this.activeDateIndex = this.calendarDateTempArr.findIndex((item, index) => {
          if (this.dateType === 'startDate') {
            return item.dateFormat === this.queryParams.startDate
          } else if (this.dateType === 'endDate') {
            return item.dateFormat === this.queryParams.endDate
          }
          return ''
        })
      }
    }
  },
  mounted () {
    this.visibleCalendar()
  },
  methods: {
    moment,
    // 当前日期
    currentDate () {
      let t = new Date()
      let day = t.getDate()
      let mon = t.getMonth() + 1
      if (mon < 10) {
        mon = '0' + mon
      }
      if (day < 10) {
        day = '0' + day
      }
      var year = t.getFullYear()
      return year + '' + mon + '' + day
    },
    // 当前日期下一个月时间
    getNextMonth () {
      var t = new Date()
      var day = t.getDate() // 获取当前日期的日
      var month = t.getMonth() + 1 // 获取当前日期的月份
      var year = t.getFullYear() // 获取当前日期的年份
      var days = new Date(year, month, 0)
      days = days.getDate() // 获取当前日期中的月的天数
      var year2 = year
      var month2 = parseInt(month) + 1
      if (month2 == 13) {
        year2 = parseInt(year2) + 1
        month2 = 1
      }
      var day2 = day
      var days2 = new Date(year2, month2, 0)
      days2 = days2.getDate()
      if (day2 > days2) {
        day2 = days2
      }
      if (month2 < 10) {
        month2 = '0' + month2
      }
      if (day2 < 10) {
        day2 = '0' + day2
      }
      var t2 = year2 + '' + month2 + '' + day2
      this.firstDataOfCurrentMonth = year + '-' + month + '-1'
      return t2
    },
    // 日历弹框展示
    showPopup (checkUnitCode, supplierId, hospitalId) {
      this.supplierId = supplierId
      this.hospitalId = hospitalId
      this.isShowCalendar = true
      this.checkUnitCode = checkUnitCode
      this.visibleCalendar()
      this.position = positions[cur++]
      if (cur === positions.length) {
        cur = 0
      }
      const component = this.$refs.myPopup4
      component.show()
    },
    // 日历弹框隐藏
    hidePopup () {
      this.isShowCalendar = false
      this.$refs.myPopup4.hide()
    },
    // 获取新的日期
    getNewDate (date) {
      let year = date.getFullYear()
      let month = date.getMonth()
      let day = date.getDate()
      return { year, month, day }
    },
    // 是否是当前月
    isCurrentMonth (date) {
      let { year: currentYear, month: currentMonth } = this.getNewDate(new Date(this.time.year, this.time.month, 1))
      let { year, month } = this.getNewDate(date)
      return currentYear == year && currentMonth == month
    },
    // 是否是今天
    isCurrentDay (date) {
      let { year: currentYear, month: currentMonth, day: currentDay } = this.getNewDate(new Date())
      let { year, month, day } = this.getNewDate(date)
      return currentYear == year && currentMonth == month && currentDay == day
    },
    // 上一个月
    prevMonth () {
      let prevMonth = new Date(this.time.year, this.time.month, 1)
      prevMonth.setMonth(prevMonth.getMonth() - 1)
      this.time = this.getNewDate(prevMonth)
      this.firstDataOfCurrentMonth = moment(prevMonth).format('YYYY-MM-DD')
      this.visibleCalendar()
    },
    // 下一个月
    nextMonth () {
      let nextMonth = new Date(this.time.year, this.time.month, 1)
      nextMonth.setMonth(nextMonth.getMonth() + 1)
      this.time = this.getNewDate(nextMonth)
      let { year, month, day } = this.time
      this.firstDataOfCurrentMonth = moment(nextMonth).format('YYYY-MM-DD')
      this.visibleCalendar()
    },
    // 回到今天
    todayEvt () {
      let time = {
        year: moment().format('YYYY'),
        month: moment().format('M') - 1,
        day: moment().format('D')
      }
      this.time = { ...time }
      this.firstDataOfCurrentMonth = moment(`${time.year}-${time.month + 1}-01`).format('YYYY-MM-DD')
      this.visibleCalendar()
      this.activeDateIndex = this.calendarDateTempArr.findIndex(item => item.day == time.day && item.month == time.month + 1)
      this[this.dateType] = moment(new Date()).format('YYYY-MM-DD')
    },
    getMonthDayTotal (year, month) {
      // 初始化date为月份的第0天，由于JavaScript中day的范围为1~31中的值，所以当设为0时，会向前一天，也即表示上个月的最后一天
      let nextMonth = month + 1
      let date = new Date(year, nextMonth, 0)
      return date.getDate()
    },
    // 获取新的日期
    getNewDate (date) {
      let year = date.getFullYear()
      let month = date.getMonth()
      let day = date.getDate()
      return { year, month, day }
    },
    // 点击日期，预约体检时间
    clickDay (item, index) {
      if (!item.enableClick) {
        return
      }
      if (this.activeDateIndex === index) {
        this.activeDateIndex = ''
        // this.queryParams[this.dateType] = ''
        this[this.dateType] = ''
      } else {
        this.activeDateIndex = index
        // this.queryParams[this.dateType] = item.dateFormat
        this[this.dateType] = item.dateFormat
      }
    },
    visibleCalendar () {
      this.calendarDateTempArr = []
      // let strDatepart = this.maxDate.split("-");
      // 获取当前时间，年，月
      let { year, month, day } = this.getNewDate(new Date(this.time.year, this.time.month, 1))
      // let { year, month, day } = this.getNewDate(new Date(strDatepart[0], strDatepart[1]-1, 1));
      let m = month + 1
      // if (m < 10) {
      //   m = '0' + m
      // }
      this.dateYYMM = year + '年' + m + '月'
      // 获取当前月的第一天
      let currentMonthFirstDay = new Date(year, month, 1)
      // 获取当前月的第一天是星期几
      let currentMonthFirstDayWeekDay = currentMonthFirstDay.getDay()
      // 总天数 =  当前月天数 + 当前月的第一天是星期几
      let dayNum = this.getMonthDayTotal(year, month) + currentMonthFirstDayWeekDay

      // todo 调用后端接口，获取本月可预约情况
      // let param = {
      //   supplierId: this.supplierId,
      //   code:this.checkUnitCode,
      //   beginDate:this.currentDate(),
      //   endDate:this.getNextMonth(),
      //   customerId: this.addAppointmentInfo.customerId || this.choosePerson.id,
      //   servicepackageId: this.addAppointmentInfo.id || this.healthInfo.servicepackageId,
      //   chooseList: this.chooseIdList,
      //   payList: this.payIdList,
      // }
      // api.getScheduleByCode(param).then(res => {
      // this.resultDateList = res.data.content
      // if (res.data.content == null) {
      //   this.resultDateList = []
      // }
      for (let i = 0; i < dayNum; i++) {
        let dateDay = new Date(currentMonthFirstDay.getTime() + ((i - currentMonthFirstDayWeekDay) * 24 * 60 * 60 * 1000))

        // 判断dateDay是否与后端返回的日期列表匹配，如果匹配继续判断是否可以预约，和处理状态

        let year = dateDay.getFullYear()
        let month = dateDay.getMonth() + 1
        let day = dateDay.getDate()
        // if (month < 10) {
        //   month = '0' + month
        // }
        // if (day < 10) {
        //   day = '0' + day
        // }
        let fullDate = year + '' + month + '' + day
        let enableClick = false
        let personCount = 0
        this.resultDateList.forEach(item => {
          if (item.scheduleDate == fullDate) {
            enableClick = true
            personCount = item.personCount
          }
        })
        // moment(`${year}-${month > 9 ? month : '0' + month}-${day} 23:59:59`).valueOf() >= moment().valueOf()
        this.calendarDateTempArr.push({
          date: dateDay,
          year: year,
          month: month,
          day: day,
          statusIndex: 1, // 状态，根据后端返回的数据决定状态值，1，假如是后端传回的状态
          enableClick: true,
          fullDate: fullDate,
          personCount: personCount,
          dateFormat: `${year}-${month > 9 ? month : '0' + month}-${day > 9 ? day : '0' + day}`
        })

        this.activeDateIndex = this.calendarDateTempArr.findIndex((item, index) => {
          if (this.dateType == 'startDate') {
            return item.dateFormat == this.queryParams.startDate
          } else if (this.dateType == 'endDate') {
            return item.dateFormat == this.queryParams.endDate
          }
          return ''
        })
      }
      // })
    },
    calendarCancel () {
      this.isShowCalendar = false
    },
    calendarConfirm () {
      // this.activeDateIndex = ''
      this.isShowCalendar = false
      // this.queryParams[this.dateType] = this[this.dateType]
      // if (moment(this.queryParams.startDate).diff(moment(this.queryParams.endDate), 'days') > 0) {
      //   this.queryParams.endDate = ''
      // }
      this.$emit('chooseDate', this[this.dateType])
    }
  }
}
</script>

<style lang="scss" scoped>
.calendar_mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.45);
  z-index: 20;
  .calendar {
    width: 100%;
    min-height: 485px;
    position: absolute;
    background: #fff;
    bottom: 0;
    left: 0;
    border-radius: 10px 10px 0px 0px;
    // padding-bottom: 27px;
    .cancel_ {
      color: #666666;
      font-size: 13px;
    }
    .choose_date {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      color: #333333;
      font-size: 15px;
    }
    .confim_{
      color: #FF7C6D;
      font-size: 13px;
    }
    .calendar_title {
      position: relative;
      padding: 0 17px;
      display: flex;
      justify-content: space-between;
      height: 45px;
      line-height: 45px;
      margin-bottom: 10px;
      background: #F9F9F9;
      border-radius: 10px 10px 0px 0px;
    }
    .calendar_current_month {
      // height: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 20px 0 25px;
      .pre_month {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 22px;
        height: 22px;
        line-height: 22px;
        background: #F3F3F3;
        border-radius: 5px;
        font-size: 8px;
      }
      .current_date {
        color: #333333;
        font-size: 12px;
        margin: 0 17px;
      }
      .next_month {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 22px;
        height: 22px;
        line-height: 22px;
        background: #F3F3F3;
        border-radius: 5px;
        font-size: 8px;
      }
      .arrow_ {
        width: 8px;
        height: 8px;
      }
    }
    // .bgImg {
    //   width: 100%;
    // }
    // .hide {
    //   position: absolute;
    //   top: 30px;
    //   left: 30px;
    //   font-size: 16px;
    //   color: #8C8C8C;
    // }
    // .title {
    //   position: absolute;
    //   top: 35px;
    //   left: 50%;
    //   font-size: 16px;
    //   transform: translate(-50%)
    // }
    .calendar-week {
      width: 100%;
      // position: absolute;
      top: 74px;
      font-size: 15px;
      display: flex;
      justify-content: space-around;
      margin-bottom: 15px;
      padding: 0 20px;
    }
    .calendar-week-item {
      width: 14.285%;
      text-align: center;
      display: inline-block;
      color: rgba(52, 72, 94, 0.54);
      font-size: 12px;

    }
    .right {
      position: absolute;
      top: 35px;
      right: 100px;
      width: 16px;
      height: 16px;
    }
    .left {
      position: absolute;
      top: 35px;
      left: 100px;
      width: 16px;
      height: 16px;
    }
    .calendarDate {
      width: 100%;
      padding: 0 20px;
      // border-bottom: 1px solid #E7E7E7;
      // position: absolute;
      // top: 105px;
      text-align: left;
      .date {
        display: inline-block;
        width: 14.285%;
        font-size: 11px;
        color: #666666;
        // height: 45px;
        text-align: center;
        &:last-child {
          margin-bottom: 30px;
        }
        &:nth-child(7n) {
          color: #FF7C6D;
        }
        .date_con {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          line-height: 34px;
          .free {
            margin-top: 10px;
            color: #4098F9;
          }
          .busy {
            margin-top: 10px;
            color: #FF6633;
          }
        }
      }
      .active {
        color: #fff;
        width: 34px;
        height: 34px;
        border-radius: 17px;
        margin-left: 6px;
        background: linear-gradient(45deg, #FF7C6C 0%, #FFA297 100%);
      }
      .disabled_ {
        color: #34485e8a;
        font-size: 11px;
      }
    }
    .line_ {
      margin: 0 20px;
      height: 1px;
      background: #E7E7E7;
    }
    .btns {
      margin: 20px 0;
      padding: 0 45px;
      display: flex;
      justify-content: space-between;
      button {
        width: 126px;
        height: 40px;
        border-radius: 5px;
        border: none;
        &:focus {
          outline: none;
          border: none;
        }
      }
      .today_ {
        color: #666666;
        background: #EAEAEA;

      }
      .confirm_ {
        color: #fff;
        background: #FF7C6D;
      }
    }
    .call_ {
      position: absolute;
      bottom: 30px;
      left: 20%;
      font-size: 12px;
      .tel {
        color: #4167F2;
      }
    }
  }
}
</style>
